import React, { type ErrorInfo } from 'react'
import { toast } from 'sonner'
type State = { error?: Error; info?: ErrorInfo }
type Props = { children?: React.ReactNode; fallback?: React.ReactNode; fallbackRender?: (props: State) => React.ReactNode }

const opts = {
  host: 'cn-hangzhou.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: 'system-test', // Project名称。
  logstore: 'fabric-cube-frontend', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: 'error', // 自定义日志主题。
  source: 'fabric-cube-frontend',
}

type SlsTrackerLike = { sendImmediate: (data: Record<string, unknown>) => void }
let trackerInstance: SlsTrackerLike | null = null
async function reportErrorToSls(error: Error) {
  if (typeof window === 'undefined') return
  try {
    if (!trackerInstance) {
      const mod = (await import('@aliyun-sls/web-track-browser')) as { default: new (options: unknown) => SlsTrackerLike }
      const SlsTracker = mod.default
      trackerInstance = new SlsTracker(opts)
    }
    if (process.env.NODE_ENV === 'production') {
      trackerInstance.sendImmediate({
        eventType: 'js_error',
        errorMessage: error.message,
        errorStack: error.stack,
        errorType: error.name,
        pageUrl: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      })
    }
  } catch (e) {
    // 避免因上报失败影响用户页面跳转
    console.warn('SLS error report failed', e)
  }
}

export class ErrorBoundary extends React.Component {
  state: Readonly<State> = {}
  props: Readonly<Props> = {}
  constructor(props: Readonly<Props>) {
    super(props)
    this.props = props
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error, info })
  }

  render() {
    const { error, info } = this.state
    const { fallbackRender, fallback } = this.props

    if (error !== undefined) {
      const props = {
        componentStack: info?.componentStack,
        error,
      }
      if (React.isValidElement(fallback)) {
        return fallback
      } else if (typeof fallbackRender === 'function') {
        return fallbackRender(props)
      } else {
        toast.error('系统异常，将在1秒后返回首页')
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem('errorInfo', JSON.stringify(error.stack))
        }
        reportErrorToSls(error).finally(() => {
          setTimeout(() => {
            if (typeof window !== 'undefined') {
              // window.location.href = '/fabric-cube'
            }
          }, 1000)
        })
        return null
      }
    }

    return this.props.children
  }
}
